<div class="container">
    <tam-dialog tid="flatfile-dialog" [opened]="dialogOpened" [dialogWidth]="684" [titleName]="'UploadFlatFile'">

        <ng-template #title tid="flatfile-title">
            <span class="dialog-title h3-regular">Upload Flat File</span>
            <smart-icon tid="flatfile-close" class="dark dialog-close" name="close" (click)="onCancelClicked()">
            </smart-icon>
        </ng-template>

        <ng-template #body tid="flatfile-body">
            <div class="upload-container">
                <div>
                    <tam-upload [config]="uploadConfig"></tam-upload>
                </div>
            </div>
        </ng-template>

        <ng-template #footer>
            <div class="footer-div">
                <div class="anotherRight">
                    <button class="button-suspend" tid="flatfile-cancel" tam-button [tamType]="'tertiary'" [tamSize]="'normal'"
                        (click)="onCancelClicked()">Cancel</button>
                    <button tam-button tid="flatfile-save" [tamType]="'primary'" [tamSize]="'normal'" [disabled]="btnDisabled"
                        (click)="onSaveClicked()">Save</button>
                </div>
            </div>
        </ng-template>

    </tam-dialog>
</div>